var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#24282C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 7.16663H8.33329C7.41663 7.16663 6.66663 7.91663 6.66663 8.83329V23.8333L9.99996 20.5H21.6666C22.5833 20.5 23.3333 19.75 23.3333 18.8333V8.83329C23.3333 7.91663 22.5833 7.16663 21.6666 7.16663ZM21.6666 18.8333H9.99996L8.33329 20.5V8.83329H21.6666V18.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.a1e8d0827c7b1c6484048debcadcb5bc.svg";
export { ForwardRef as ReactComponent };